function childrenLineArray(item, level) {
    let children = item.children || []
    item.level = level
    if (children.length > 0) {
        for (let i = (children.length - 1); i >= 0; i--) {
            const child = children[i];
            child.parentKey = item.rightKey
            let children2 = childrenLineArray(child, level + 1)
            children.splice(i + 1, 0, ...children2)
        }
    }
    return children
}
export const translatePermission = (menuItems) => {
    //translate to line array
    for (let i = (menuItems.length - 1); i >= 0; i--) {
        const item = menuItems[i];
        item.parentKey = ''
        let children = childrenLineArray(item, 1)
        menuItems.splice(i + 1, 0, ...children)
        delete item.children
    }

    menuItems.map((r) => ({ ...r, isRead: false, isWrite: false, isChange: false, isDelete: false, }))
}

export const FILTER_PERMISSION = (menuItems, hasRight, prefix = '') => {
    let items = menuItems.filter((item) => {
        if (item.path) {
            let r = CLIENT_PORTAL_RIGHTS.find(c => {
                let cpaths = c.path
                if (cpaths && typeof cpaths === 'string') {
                    let pp = cpaths.split(/[/]+/).filter(c => c)
                    if (prefix && pp[0] === prefix && pp.length > 1) {
                        pp.splice(0, 1)
                    }
                    if (pp.length) {
                        let p = `/${pp.join('/')}`
                        return (item.path.indexOf(p) === 0)
                    }
                }
                if (Array.isArray(cpaths)) {
                    for (let path of cpaths) {
                        let pp = path.split(/[/]+/).filter((p) => p)
                        if (prefix && pp[0] === prefix && pp.length > 1) {
                            pp.splice(0, 1)
                        }
                        if (pp.length) {
                            let p = `/${pp.join('/')}`
                            if (item.path.indexOf(p) === 0) {
                                return true
                            }
                        }
                    }
                }
                return false
            })
            if (r) {
                let k = `${r.rightKey}`
                let per = hasRight && hasRight(k)
                return per
            }
        }
        return true
    })
    return items
}

export const CLIENT_PORTAL_RIGHTS = [
    {
        rightKey: 'HOME',
        parentKey: '',
        name: 'Home',
        path: '/dashboard/home',
        level: 1,
        children: []
    },
    {
        rightKey: 'DASHBOARD',
        parentKey: '',
        name: 'Dashboard',
        path: '/dashboard/basic',
        level: 1,
        children: [
            {
                rightKey: 'DAS_REQUEST_SUM',
                parentKey: 'DASHBOARD',
                name: 'Request Summary',
            },
            {
                rightKey: 'DAS_ASSET_SUM',
                parentKey: 'DASHBOARD',
                name: 'Asset Summary',
            },
            {
                rightKey: 'DAS_SETTLEMENT_SUM',
                parentKey: 'DASHBOARD',
                name: 'Settlement Summary',
            },
            {
                rightKey: 'DAS_SLA_SUM',
                parentKey: 'DASHBOARD',
                name: 'SLA Summary',
            },
            {
                rightKey: 'DAS_REPORT_SUM',
                parentKey: 'DASHBOARD',
                name: 'Report Summary',
            },
        ]
    },
    {
        rightKey: 'SRV_REQ',
        parentKey: '',
        name: 'Service Request',
        path: '/dashboard/service-request',
        level: 1,
        children: [
            {
                rightKey: 'REQUEST_LIST',
                parentKey: 'SRV_REQ',
                name: 'Request List',
            },
            {
                rightKey: 'UPDATE_ASSET',
                parentKey: 'SRV_REQ',
                name: 'Update Asset',
                level: 2,
            },
            {
                rightKey: 'CONTAINER_LIST',
                parentKey: 'SRV_REQ',
                name: 'Container List',
            },
            {
                rightKey: 'ASSET_LIST',
                parentKey: 'SRV_REQ',
                name: 'Asset List',
            },
            {
                rightKey: 'REC_REQUEST_LIST',
                parentKey: 'SRV_REQ',
                name: 'Recursive Request List',
            },
        ]
    },
    {
        rightKey: 'DOCUMENT',
        parentKey: '',
        name: 'Document',
        path: '/dashboard/documents',
        level: 1,
        children: [
            {
                rightKey: 'DOC_STANDARD',
                parentKey: 'DOCUMENT',
                name: 'Standard Reports',
            },
            {
                rightKey: 'DOC_SERVICE',
                parentKey: 'DOCUMENT',
                name: 'Service Documents',
            },
            {
                rightKey: 'DOC_OTHER',
                parentKey: 'DOCUMENT',
                name: 'Other Documents',
            },
        ]
    },
    {
        rightKey: 'IMPORT_REQUEST',
        parentKey: '',
        name: 'Import Request',
        path: '/dashboard/import-request',
        level: 1,
    },
    {
        rightKey: 'SUPPORT',
        parentKey: '',
        name: 'Support',
        path: '/dashboard/support',
        level: 1,
        children: [
            {
                rightKey: 'NOTICE',
                parentKey: 'SUPPORT',
                name: 'Notice',
            },
            {
                rightKey: 'FAQ',
                parentKey: 'SUPPORT',
                name: 'FAQ',
            },
            {
                rightKey: 'CONTACT_US',
                parentKey: 'SUPPORT',
                name: 'Contact Us',
            },
        ]
    },
    {
        rightKey: 'SETTING',
        parentKey: '',
        name: 'Setting',
        path: '/dashboard/setting',
        level: 1,
        children: [
            {
                rightKey: 'MASTER_DATA',
                parentKey: 'SETTING',
                name: 'Master Data',
            },
            {
                rightKey: 'USER_MNG',
                parentKey: 'SETTING',
                name: 'User Management > User List',
            },
            {
                rightKey: 'USER_GROUP_MNG',
                parentKey: 'SETTING',
                name: 'User Management > User Group',
            },
            {
                rightKey: 'USER_ACCESS_REQUEST',
                parentKey: 'SETTING',
                name: 'User Management > Access Request',
            },
            {
                rightKey: 'DEALER_APPROVAL',
                parentKey: 'SETTING',
                name: 'User Management > Dealer Approval',
            },
        ]
    }
]

translatePermission(CLIENT_PORTAL_RIGHTS)
